export default __webpack_public_path__ + "static/media/Thumbnail6.ab95ac42.jpg";